export const APPROVAL_WORK_FLOW_RIGHTS = {
  readApprovalWorkFlows: "ReadApprovalWorkFlows",
  writeApprovalWorkFlows: "WriteApprovalWorkFlows",
};

export const GENERAL_RIGHTS = {
  editForm: "EditForm",
  readApiDocumentation: "ReadApiDocumentation",
  viperUser: "ViperUser",
  createIntake: "CreateIntake",
};

export const PERMISSION_RIGHTS = {
  readPermissions: "ReadPermissions",
  writePermissions: "WritePermissions",
};

export const PROJECT_RIGHTS = {
  createProjectMilestone: "CreateProjectMilestone",
  createProjects: "CreateProjects",
  deleteProjectMilestone: "DeleteProjectMilestone",
  editCompletedProject: "EditCompletedProject",
  editCompletedProjectMilestone: "EditCompletedProjectMilestone",
  editProjectMilestone: "EditProjectMilestone",
  editProjectMilestoneDates: "EditProjectMilestoneDates",
  readAllProjects: "ReadAllProjects",
  writeAllProjects: "WriteAllProjects",
  resetProjectMilestoneStatus: "ResetProjectMilestoneStatus",
  writeMyProjects: "WriteMyProjects",
  changeProjectStatus: "ChangeProjectStatus",
  cancelProjects: "CancelProjects",
  completeProjects: "CompleteProjects",
  viewCompletedProjects: "ViewCompletedProjects",
  viewSecureCompletedProjects: "ViewSecureCompletedProjects",
  viewSecureProjects: "ViewSecureProjects",
};

export const TEMPLATE_RIGHTS = {
  publishTemplates: "PublishTemplates",
  readTemplates: "ReadTemplates",
  writeTemplates: "WriteTemplates",
};

export const USER_RIGHTS = {
  impersonateUsers: "ImpersonateUsers",
  readUsers: "ReadUsers",
  massReplaceUsers: "MassReplaceUsers",
  replaceProjectUsers: "ReplaceProjectUsers",
};

export const NOTIFICATION_GROUP_RIGHTS = {
  readNotificationGroups:
    // TODO: User Story 34420: Update Distribution Group Naming
    // https://dev.azure.com/MilwaukeeToolAppDev/Moon%20Men/_workitems/edit/34420
    "ReadDistributionGroups",
  writeNotificationGroups:
    // TODO: User Story 34420: Update Distribution Group Naming
    // https://dev.azure.com/MilwaukeeToolAppDev/Moon%20Men/_workitems/edit/34420
    "WriteDistributionGroups",
};

export const HIDE_USER_RIGHTS = {
  hideViperUser: "HideViperUser",
};

export const BASELINE_DATE_RIGHTS = {
  readBaselineDates: "ReadBaselineDates",
  writeBaselineDates: "WriteBaselineDates",
};

const RIGHTS = {
  ...APPROVAL_WORK_FLOW_RIGHTS,
  ...GENERAL_RIGHTS,
  ...PERMISSION_RIGHTS,
  ...PROJECT_RIGHTS,
  ...TEMPLATE_RIGHTS,
  ...USER_RIGHTS,
  ...NOTIFICATION_GROUP_RIGHTS,
  ...HIDE_USER_RIGHTS,
  ...BASELINE_DATE_RIGHTS,
};

export default RIGHTS;
